import { i18n } from '@fs/zion-locale'

export default {
  editButtonText: () => i18n.t('GroupDataHeader.editButtonText', 'Edit'),
  heading: () => i18n.t('GroupDataHeader.heading', 'Image Group Data'),
  subHeading: (x, y) =>
    i18n.t('GroupDataHeader.metadataItemOfGroupTotal', 'Metadata describing Item {x} of {y}', { x, y }),
  tooltipLabel: (index, total) => i18n.t('GroupDataHeader.tooltipLabel', 'Item {index} of {total}', { index, total }),
  tooltipDescription: (itemNumber, startIndex, endIndex, initialImages) =>
    i18n.t(
      'GroupDataHeader.tooltipDescription',
      'Item {itemNumber} is a group containing images {startIndex}–{endIndex} of an image group that originally had {initialImages} images.',
      { itemNumber, startIndex, endIndex, initialImages }
    ),
  tooltipAria: () => i18n.t('GroupDataHeader.tooltipAria', 'More item information'),
  prevButton: () => i18n.t('GroupDataHeader.prevButton', 'Previous'),
  nextButton: () => i18n.t('GroupDataHeader.nextButton', 'Next'),
  wholeGroup: () => i18n.t('GroupDataHeader.wholeGroup', 'Metadata describing the entire group of images'),
  redactImage: () => i18n.t('GroupDataHeader.redactImage', 'Redact Image'),
  selectItem: () => i18n.t('GroupDataHeader.selectItem', 'Select Item'),
  goToPreviousItem: () => i18n.t('GroupDataHeader.goToPreviousItem', 'Go to previous item'),
  goToNextItem: () => i18n.t('GroupDataHeader.goToNextItem', 'Go to next item'),
}
